import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmark: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBookmark"><Path d="M4 2V22.7232L12 18.1517L20 22.7232V2H4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookmark;
